import React from "react";
import "./CareerCoachModule.css";
import coachImage from "../Images/coach.png";
import tcsLogo from "../Images/tcs.png";
import skillshapLogo from "../Images/skillshap.png";
import orderzyLogo from "../Images/orderzy.png";
import corizoLogo from "../Images/corizo.png";
import careerDwarLogo from "../Images/careerdwar.png";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';

const CareerCoachModule = () => {
  return (
    <div className="careercoach-main">
      <br>
      </br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <div className="careercoach-container">
        {/* RIGHT SECTION FIRST: Text content */}
        <div className="careercoach-right">
          <p className="careercoach-label">FOR CAREER COACHES</p>
          <h2>
            Empower your <br /> coaching practice <br />
            with a suite of <span className="highlight">AI Career Tools</span>
          </h2>
          <p className="careercoach-subtext">
            Workflows driven by AI can decrease manual labor, enable metric tracking, and enhance student results.
          </p>
          <div className="careercoach-button-wrapper">
            <Link to="/BookDemoForm">
              <button className="careercoach-button-1">SCHEDULE A DEMO</button>
            </Link>
          </div>
        </div>

        {/* LEFT SECTION SECOND: Image */}
        <div className="careercoach-left">
          <div className="careercoach-image-wrapper">
            <div className="careercoach-circle-bg animate-circle"></div>
            <img src={coachImage} alt="Career Coach" className="careercoach-img" />
          </div>
        </div>
      </div>


      {/* <div className="careercoach-trusted-section">
        <h2 className="careercoach-trusted-title">How Top Career Coaches Trust SkillsHap</h2>
        <p className="careercoach-trusted-subtitle">
          We have worked with coaching organizations and career coaches in a variety of industries and regions.
        </p>

        <div className="careercoach-logos">
          <img src={tcsLogo} alt="TCS" className="careercoach-logo" />
          <img src={skillshapLogo} alt="Skillshap" className="careercoach-logo" />
          <img src={orderzyLogo} alt="Orderzy" className="careercoach-logo" />
          <img src={corizoLogo} alt="Corizo" className="careercoach-logo" />
          <img src={careerDwarLogo} alt="Career Dwar" className="careercoach-logo" />
        </div>
      </div> */}

      <div className="careercoach-demo-wrapper">
        <div className="careercoach-demo-left">
          <h2>
            Curious to see <br />
            <span>how it works?</span> <br />
            Schedule a demo today!
          </h2>
          <p>
            Experience how SkillsHap modernizes your career coaching service with AI tools.
            Help your clients build the career they want.
          </p>
        </div>

        <div className="careercoach-demo-card">
          <div className="careercoach-blob blob1"></div>
          <div className="careercoach-blob blob2"></div>

          <div className="careercoach-demo-content">
            <div className="careercoach-demo-icon">📞</div>
            <h3>Book a Call Now</h3>
            <p>
              Schedule your meeting effortlessly with Calendly! Just click the link below to find the perfect time.
            </p>
            <Link to="/BookDemoForm"> <a href="#" className="careercoach-button">BOOK CALL NOW →</a></Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerCoachModule;
